import Breadcrumbs from "@material-ui/core/Breadcrumbs/Breadcrumbs";
import Checkbox from "@material-ui/core/Checkbox/Checkbox"
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel"
import makeStyles from "@material-ui/core/styles/makeStyles";
import { api, IconFlechaDerecha } from '@portal/arq-portal-core';
import Typography from "@material-ui/core/Typography/Typography";
import { HomeWidget } from '@portal/arq-portal-core';
import React, { useEffect, useState } from "react"
import { SoftwareList } from "./SoftwareList";
import { SoftwareItem } from "./SoftwareItem";
import Link from "@material-ui/core/Link/Link";
//import useGetDirectory from "../hooks/useGetDirectory";
import { mutate } from "swr";

const useEstilos = makeStyles((theme) => ({
    softwareContainer: {
        marginTop: '0.75rem',
        '&  .MuiTypography-body1': {
            fontSize:'12px',
            color: '#606060'
        },
        overflowY: 'scroll',
        maxHeight: '340px',
    },
    breadcrumb: {
        marginTop: '0.75rem',
        '& p': {    
            fontSize: '12px',
            color: '#606060',
            marginTop: '-2px'
        },  
        '& a': {
            fontSize: '12px',
            color: '#DC0028',
            borderBottom: '1px solid #DC0028',
            textDecoration: 'none !important',
            float: 'left', 
            marginTop: '-1px'
        },
        '& .MuiBreadcrumbs-separator': {
            marginLeft: '4px',
            marginRight: '4px',
            height:'20px',
            marginTop:'-5px'
        },
        '& .MuiBreadcrumbs-ol li': {
            display: 'inline-block',
        },
    },
    breadcrumbItem: {
        '&:hover': {
            cursor: "pointer",
        }
    },
    breacrumbIcon: {
        width: '10px'
    },
    activarSus:{
        '& .MuiTypography-body1': {
            fontSize: '12px',
            color: '#606060'
        }
    },
    softwareListItem: {
        borderBottom: '1px solid #d6d8d8',
        '& .itemWrapper': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px 0',
            position: 'relative',
            '& .widgetIcon': {
                padding: '0',
                color: '#606060',
                '&:last-of-type': {
                    paddingLeft: '5px',
                },
                '&:hover': {
                    color: '#919191',
                    backgroundColor: 'inherit',
                },
                '&:active': {
                    color: theme.palette.primary.main,
                },
                '& i': {
                    fontSize: '28px',
                    lineHeight: '0.8',
                },
                '& .MuiTouchRipple-root': {
                    display: 'none'
                },
            },
        },
    },
    checkbox: {
        '& .MuiSvgIcon-root': {
            color: '#606060',
        },
        '&:hover .MuiSvgIcon-root': {
            color: '#919191',
        },
        '&:focus .MuiSvgIcon-root': {
            color: '#DC0028',
        },
        '&:active .MuiSvgIcon-root': {
            color: '#DC0028',
        }
    }
}));

interface DocumentsNavigation {
    value: string;
    title: string;
}

interface SoftwareProps {
    title?: string;
}

export const Software = (props: SoftwareProps) => {
    
    const clases = useEstilos(props);
    //const { data } = useGetDirectory();
    const [documents, setDocuments] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(undefined);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [selectedFolder, setSelectedFolder] = useState<any[]>([]);
    const [navigation, setNavigation] = useState<DocumentsNavigation[]>([
        {
            title: "Inicio",
            value: ""
        }
    ]);

    useEffect( () => {
        api.getAsync("/be/descargasoftware/").then( data => {
            setDocuments(data.Salida.Directorio.Documentos);
            setIsSubscribed(data.Salida.Directorio.Suscripcion === "1" ? true : false);
            setSelectedFolder(data.Salida.Directorio.Documentos);
        }).catch((error)=>{
            setError(error?.message);
        }).finally(( )=>{
            setIsLoading(false);
        });
    }, []);

    const handleFolderNavigation = (folder:any, index:number) => {
        let lastIndexValue = navigation[navigation.length-1].value;
        let routeIndexs = lastIndexValue+`;${index}`
        if(lastIndexValue === "") routeIndexs = `${index}`;
        let newNavigation = [...navigation, {
            title: folder.Titulo,
            value: routeIndexs
        }];
        let newFolderDocuments = selectedFolder[index].Documentos;
        setNavigation(newNavigation);
        setSelectedFolder([...newFolderDocuments]);
    }

    const handleCheckbox = () => {
        setIsSubscribed(!isSubscribed);
        mutate(["suscripciondescargasoftware"], () => api.post("/be/suscripciondescargasoftware/", {Entrada:{Suscrito: !isSubscribed}}), false);
    }

    const getFolderFromRoute = (routeToFolder:string) => {
        var routeIndexs = routeToFolder.split(";");
        let folderDocuments = documents;
        routeIndexs.forEach( val => {
            if(val !== '') folderDocuments = folderDocuments[val].Documentos
        });
        return folderDocuments;
    }

    const handleBreadcrumb = (routeToFolder:string, index:number) => {
        navigation.length=index+1; //borrar la parte derecha del array
        setNavigation([...navigation]);
        setSelectedFolder([...getFolderFromRoute(routeToFolder)]);
    }

    const renderBreadcrumbs = () => {
        const breadcrumb = navigation.map( (nav, index) => {
            if(index+1 === navigation.length) return <Typography key={index}>{nav.title}</Typography>
            else return <Link className={clases.breadcrumbItem} underline="hover" key={index} color="inherit" onClick={() => handleBreadcrumb(nav.value, index)} >{nav.title}</Link>
        });
        return breadcrumb;
    }

    const findAndDeleteItem = (id:string, documents:any[]) => {
        let i = 0;
        let found = false;
        while(i < documents.length && !found){
            if(id === documents[i].Id){
                documents.splice(i, 1);
                found = true;
                i--;
            }else{
                if(documents[i].IsFolder){
                    findAndDeleteItem(id, documents[i].Documentos);
                }
            }
            i++;
        }
    }

    const handleItemDelete = (item: any) => {
        findAndDeleteItem(item.Id, documents);
        let routeToFolder = navigation[navigation.length-1].value;
        setSelectedFolder([...getFolderFromRoute(routeToFolder)]);
        setDocuments([...documents]);
    }

    const listItems = selectedFolder?.map((item: any, index: number) => {
        if(item === undefined) return null;
        return (
            <li className={clases.softwareListItem} key={index}>
                <div className="itemWrapper">
                    <SoftwareItem item={item} onItemDelete={ () => handleItemDelete(item) } onFolderNavigation={ () => handleFolderNavigation(item, index) } />
                </div>
            </li>
        )
    });

    return (
        <HomeWidget titulo={props.title ? props.title : "Descarga de datos"} isLoading={isLoading} error={error} >
            {isLoading ? undefined :
                <React.Fragment> 
                    <Breadcrumbs maxItems={2} className={clases.breadcrumb} separator={<IconFlechaDerecha className={clases.breacrumbIcon} />} aria-label="breadcrumb">
                        {renderBreadcrumbs()}
                    </Breadcrumbs> 
                    <div className={clases.softwareContainer}>
                        <SoftwareList items={listItems} />
                    </div>
                    <FormControlLabel className={clases.activarSus}
                        control={
                            <Checkbox 
                                classes={{
                                    root: clases.checkbox
                                }}
                                onClick={handleCheckbox} 
                                checked={isSubscribed}
                            />
                        } 
                        label="Activar suscripción" 
                    />
                </React.Fragment>}
        </HomeWidget>
    )
}